export enum AdminCacheKeys {
  Facility = 'admin-facility',
  FacilityUsers = 'admin-facility-users',
  FacilityRoles = 'facility-users',
  AdminTimezones = 'admin-timezones',
  FacilitiesEmployees = 'admin-facilities-employees',
  AdminFacilityMenu = 'admin-facility-menu',
  GlobalUsers = 'global-users',
  MinRequiredMobileVersion = 'min-required-mobile-version',
}
